import { useEffect, useState } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("gk_cookie_consent")) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("gk_cookie_consent", "accepted");
    setShow(false);
  };

  const reject = () => {
    localStorage.setItem("gk_cookie_consent", "rejected");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-12 py-5 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
        <div className="text-sm text-[#0A2540]/80 leading-relaxed max-w-2xl">
          <strong className="text-[#0A2540]">Çerez Kullanımı.</strong>{" "}
          Web sitemizde, deneyiminizi geliştirmek ve hizmetlerimizi iyileştirmek
          için çerezler kullanıyoruz. Devam ederek çerez kullanımını kabul etmiş
          olursunuz.
        </div>
        <div className="flex gap-2 w-full md:w-auto">
          <button
            onClick={reject}
            className="flex-1 md:flex-none px-5 py-2.5 text-sm font-medium border border-slate-300 hover:bg-slate-50"
            data-testid="cookie-reject"
          >
            Reddet
          </button>
          <button
            onClick={accept}
            className="flex-1 md:flex-none px-5 py-2.5 text-sm font-semibold bg-[#0A2540] text-white hover:bg-[#0066FF] transition-colors"
            data-testid="cookie-accept"
          >
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
}
